import React from 'react';

const OnDisplayContext = React.createContext({
  onDisplayClick: false,
  setOnDisplayClick: (_value) => {}
});

export default OnDisplayContext;